import React from 'react';
import ContentIconAtom from '@atoms/icon-atoms/content-icon-atoms';
import styled from '@emotion/styled/macro';
import Translate from '@utils/translation-functions';
import vars from '@variables';
import {
  useClearRefinements,
  UseClearRefinementsProps,
} from 'react-instantsearch';

const CustomClearRefinements: React.FC<UseClearRefinementsProps> = props => {
  const { refine } = useClearRefinements(props);

  return (
    <button onClick={() => refine()} role="menuitem">
      <ContentIconAtom contentType="all" backgroundFill="none" />
      <br />
      {Translate('All', true)}
    </button>
  );
};

const StyledClearRefinements = styled(CustomClearRefinements)`
  color: ${vars.coreDarkGrey};
  margin: 0px;
  font-weight: ${vars.fontWeightRegular};
  width: 6rem;
  height: 7rem;
  padding-bottom: 0.7rem;
  text-align: center;
  border: none;
  border-bottom: 0.4rem solid #2f2f46;
  background-color: #ffffff;
  cursor: pointer;
  &:hover {
    background-color: #f2f2f2;
  }
  &:disabled {
    cursor: auto;
    border-color: #d8d8d8;
    opacity: 0.7;
    &:hover {
      background-color: #ffffff;
    }
    &:focus {
      background-color: none;
    }
  }
`;

export default StyledClearRefinements;
